<template>
  <div ref="editorDOM">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <div class="mobileTable" v-if="SCREEN.mobile">
        <div class="Title">体检套餐</div>
        <div
          class="tableData"
          v-for="(item, index) in medicalExamData"
          :key="index"
        >
          <div class="item" @click="savePhysicalEaxmInfo(item)">
            <div class="left">套餐名称：</div>
            <div class="right">{{ item.packageName }}</div>
          </div>
          <div class="item">
            <div class="left">所属性别：</div>
            <div class="right" v-if="item.packageSex==1">男</div>
            <div class="right" v-if="item.packageSex==2">女</div>
            <div class="right" v-if="item.packageSex==3">通用</div>
          </div>
          <div class="item">
            <div class="left">套餐价格：</div>
            <div class="right">{{ item.packagePrice }}</div>
          </div>
        </div>
      </div>
      <div class="tablebox" v-else>
        <div class="Title">体检套餐</div>
        <a-table
          :columns="columns"
          :data-source="medicalExamData"
          :pagination="false"
        >
          <span slot="sex" slot-scope="text, record">
            <span v-if="record.packageSex==1">男</span>
            <span v-if="record.packageSex==2">女</span>
            <span v-if="record.packageSex==3">通用</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a
              slot="action"
              href="javascript:;"
              @click="savePhysicalEaxmInfo(record)"
              >{{ text }}</a
            >
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hospital-physicalExaminationPackageList-001-sz",
  data() {
    return Object.assign(
      {
        columns: [
          {
            title: "套餐名称",
            dataIndex: "packageName",
            key: "packageName",
            scopedSlots: {
              customRender: "action"
            }
          },
          // {
          //   title: "所属性别",
          //   dataIndex: "packageSex",
          //   key: "packageSex"
          // },
          {
            title: "所属性别",
            dataIndex: "packageSex",
            key: "packageSex",
            scopedSlots: {
              customRender: "sex"
            }
          },
          {
            title: "套餐价格",
            dataIndex: "packagePrice",
            key: "packagePrice"
          }
        ],
        medicalExamData: [
          // {
          //   packageName: "全面体检套餐（女未婚）",
          //   packageSex: "女未婚",
          //   packagePrice: "￥1220.50（单价：元）",
          // packageCode
          // },
          // {
          //   packageName: "全面体检套餐（男）",
          //   packageSex: "男",
          //   packagePrice: "￥1200.50（单价：元）"
          // }
        ],
        hospitalCode: 'H06',
      }
    );
  },

  mounted() {
    this.getMedicalExamList();
  },

  methods: {
    savePhysicalEaxmInfo(item) {
      this.$router.push({
          path: '/medicalCenter/medicalPackageDetails',
          query: { packageSex:item.packageSex,packageCode: item.packageCode},
        })
    },
    getMedicalExamList() {
      this.$API
        .getMedicalExamList({
          hospitalCode: this.hospitalCode
        })
        .then(res => {
          this.$set(this, "medicalExamData", res.data);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.Title{
  text-align: center;
  font-size: 0.4rem;
  padding-bottom: 0.4rem;
}
.mobileTable {
  padding-top: 0.4rem;
  .tableData {
    margin-bottom: 0.2rem;
    .item {
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: center;
      font-size: 0.28rem;
      padding: 0.2rem 0;
      .left {
        width: 30%;
        text-align: right;
      }
      .right {
        width: 70%;

        padding-left: 0.1rem;
      }
    }
    .item:last-child {
      border-bottom: 1px solid #ddd;
    }
  }
  .more {
    padding: 0.4rem 0;
    display: flex;
    justify-content: center;
    .btn {
      font-size: 0.28rem;
      display: inline-block;
      vertical-align: top;
      border: 1px solid;
      border-radius: 1rem;
      padding: 0.1rem 0.3rem;
    }
  }
}
.windowInfoWrap {
  padding-bottom:30px;
  .tablebox {
    margin-top: 42px;
    /deep/.ant-table-thead > tr:first-child > th {
      background: #0078d4;
      font-size: 16px;
      height: 56px;
      text-align: center;
      color: #fff;
      font-weight: 100;
      border-left: 2px solid #fff;
    }
    /deep/.ant-table-tbody > tr > td {
      text-align: center;
      color: #474747;
      a {
        color: #474747;
      }
    }
  }
}

.m-screen-mobile {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  margin-bottom: 1rem;
}
</style>
